import cms from "../../assets/project-cms.jpg";
import automation from "../../assets/project-automation.jpg";
import ai from "../../assets/project-ai.jpg";
import his from "../../assets/project-his.png";
import forecast from "../../assets/project-forecasting.png";

const projects = [
  {
    image: ai,
    title: "E-Commerce AI-Powered Development",
    role: "Technical Lead",
    bullets: [
      "Led the design and implementation of an AI-driven e-commerce platform, integrating advanced machine learning algorithms for personalized product recommendations, dynamic pricing, and customer behavior analysis.",
      "Architected a microservices-based backend using .NET Core, ensuring scalability and maintainability while leveraging cloud services for AI model hosting and data processing.",
      "Collaborated with cross-functional teams to define AI use cases, resulting in a 25% increase in conversion rates and a 30% improvement in customer retention.",
        "Implemented robust data pipelines and monitoring systems to ensure the reliability and performance of AI features, while maintaining compliance with data privacy regulations.",
    ],
    tags: ["C#", ".Net Core 8.0", "Angular", "Azure Open API", "Prompt Engineering", "Architecture"],
  },
  {
    image: automation,
    title: "Aggregater for OOH Media",
    role: "Technical Lead",
    bullets: [
      "This is a DOOH and OOH advertising business that was founded on the intention to add meaning to its campaigns while also delivering on its brand performance promises."
      ,"The company’s main goal is to use data and technology to create more effective and engaging advertising campaigns that resonate with consumers. By leveraging data insights, the company can better understand consumer behavior and preferences, allowing them to create campaigns that are more relevant and personalized."
      ,"Additionally, the company aims to deliver on its brand performance promises by using technology to optimize campaign performance and ensure that it meets the desired outcomes. Overall, the company is focused on creating a more meaningful and impactful advertising experience for both brands and consumers through the use of data and technology."
    ],
    tags: ["C#", ".Net Core 8.0", "Angular", ".Net Core API", "Entity Framework 8.0", "AWS Services"],
  },
  {
    image: forecast,
    title: "Product Forecast and Data Processing Tools",
    role: "Technical Lead",
    bullets: [
      "For Nursery Plant Products Demand Forecasting based on previous year sales data. Order and Inventory Management Tools for a large retail client to optimize procurement and stock levels. Web Scraping tools for competitive pricing analysis and market research."
      ,"These tools were developed to automate and optimize various aspects of the client's operations, including demand forecasting, inventory management, and market research. By leveraging data and technology, these tools help the client make more informed decisions, improve efficiency, and stay competitive in the market."
      ,"Implemented robust data pipelines and monitoring systems to ensure the reliability and performance of AI features, while maintaining compliance with data privacy regulations."
    ],
    tags: ["C#", ".Net Core 6.0", ".NET 4.2", "MVC", ".Net Core API", "Entity Framework 8.0", "AWS Services", "Azure Services", "Web Scraping"],
  },
  {
    image: his,
    title: " Hospital Information System",
    role: "Sr. Software Engineer ",
    bullets: [
      "It is in under development. It covers almost all department of hospital like Pharmacy, Registration Accomodatio Discharge and Transfer (RADT), Operation Theater, Diet, Blood bank, EHR, Billing etc."
      ,"I have worked on Pharmacy Module which is responsible for maintaining the complete inventory of Pharmacy store. It also has features like generating prescription from EHR, maintaining stock of medicines, generating purchase order for medicines etc."
      ,"I have also worked on design new Microservice Architechture and API Gateway for same Application. This will help to scale application and also to add new features in future without impacting existing system."
    ],
    tags: ["C#", ".Net Core 6.0", ".NET 4.2", "MVC", ".Net Core API", "Entity Framework 8.0", "AWS Services", "Azure Services", "Web Scraping"],
  },
];

export function Projects() {
  return (
    <section id="projects" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 max-w-2xl">
          <p className="font-mono text-sm text-primary">// Featured Projects</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Selected work, shipped at scale.
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
          {projects.map((p) => (
            <article
              key={p.title}
              className="group relative flex flex-col overflow-hidden rounded-xl border border-border bg-surface transition-smooth hover:-translate-y-2 hover:border-primary/50 hover:shadow-elevated"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  width={1024}
                  height={768}
                  className="h-full w-full object-cover transition-smooth group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col gap-4 p-6">
                <h3 className="text-xl font-semibold text-foreground transition-smooth group-hover:text-primary">
                  {p.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{p.role}</p>
                <ul className="mt-4 space-y-2 text-sm text-muted-foreground leading-relaxed md:text-base self-start">
                  {p.bullets.map((b, i) => (
                    <li key={i} className="flex gap-3">
                      <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="flex flex-wrap gap-2 pt-2">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md border border-border bg-background/60 px-2 py-1 font-mono text-xs text-muted-foreground"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
